import { Component, Prop} from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';

import './style.less';

interface ISuccess {
  click?: any;
  subTitle?: string;
  type?: number;
}

@Component
export default class Success extends tsx.Component<ISuccess> {
  
  @Prop() public click?: any;
  @Prop() public subTitle?: string;
  @Prop() public type?: number;
  
  
  getData() {
    console.log(this.$props.type);
    switch (this.$props.type) {
      case 1:
        return {
          svg: require('@/assets/svg/waiting.svg'),
          title: '支付成功',
          subtitle: '等待分配设备中'
        }
      
      case 2:
       return  {
         svg: require('@/assets/svg/success.svg'),
         title: '分配成功',
         subtitle: this.$props.subTitle
       }
      case 3:
        return  {
          svg: require('@/assets/svg/error.svg'),
          title: '分配失败',
          subtitle: ''
        }
      default:
        return {
          svg: require('@/assets/svg/waiting.svg'),
          title: '支付成功',
          subtitle: '等待分配设备中'
        }
    }
  }
  
  render() {
    const {click = () => {},} = this.$props;
    return (
      <div class='success-container'>
        <img class='img' src={this.getData().svg} alt=""/>
        <div class='title'>{this.getData().title}</div>
        <div class='sub-title'>{this.getData().subtitle}</div>
        {this.$props.type === 2 ?
          <div class='button' onClick={click}>立即体验云手机</div> :
          <div class='button' onClick={click}>返回首页</div>
        }
      </div>
    )
  }
  
}